export enum QueryKeys {
    Accounts = 'v1:radius:accounts',
    PaginatedAccounts = 'v1:radius:paginated:accounts',
    LoginHistory = 'v1:radius:login:history',
    OnlineUsers = 'v1:radius:online:users',
    PaginatedOnlineUsers = 'v1:radius:paginated:online:users',
    PaginatedLoginHistory = 'v1:radius:paginated:login:history',
    PaginatedServers = 'v1:radius:paginated:servers',
    PaginatedUsers = 'v1:radius:paginated:users',
    Servers = 'v1:radius:servers',
    Users = 'v1:radius:users',
    User = 'v1:radius:user',
    UserUsage = 'v1:radius:user:usage',
}
